import classNames from 'classnames';
import { t } from 'ttag';

import { PaymentMethodEnum } from '@newModels';
import { SafePaymentBenefitsBanner, SellerPlacement } from '@components/SafePaymentBenefitsBanner';
import { PaymentMethodToggleContainer } from '@containers/settings/PaymentMethodToggle';
import { Alert } from '@ui/Alert';

import s from './ShopSettingsPaymentMethods.sss';

interface PaymentMethod {
  id: PaymentMethodEnum,
  isEnabled: boolean,
  isHidden: boolean,
  name: string,
  description: string,
  descriptionIfHidden: string,
  icon: string,
}

interface Props {
  paymentMethods: PaymentMethod[],
  placement: SellerPlacement,
  isUserRestrictedByBankId: boolean,
  isRozetkaDeliveryEnabled: boolean,
}

export const ShopSettingsPaymentMethods: React.FC<Props> = ({
  paymentMethods,
  placement,
  isUserRestrictedByBankId,
  isRozetkaDeliveryEnabled,
}) => {
  if (!paymentMethods.length) {
    return null;
  }

  const safePaymentMethod = paymentMethods.find(
    (method) => method.id === PaymentMethodEnum.SafePayment,
  );
  const isSafePaymentBannerVisible = (
    safePaymentMethod
    && !safePaymentMethod.isEnabled
  );

  return (
    <>
      {
      isUserRestrictedByBankId && (
        <Alert theme="warning" className={s.alert}>
          {t`Наразі вам доступний тільки один спосіб оплати покупцем
          - Безпечна оплата. Верифікуйте свій профіль,
          щоб отримати більше можливостей. Це займе 3 хвилини`}
        </Alert>
      )
    }
      {isSafePaymentBannerVisible && (
      <SafePaymentBenefitsBanner
        className={s.banner}
        type="seller"
        placement={placement}
      />
      )}
      <ul className={s.list}>
        {paymentMethods.map((method) => (
          <li
            key={method.id}
            className={classNames(s.item, {
              [s.itemPlacementModal]: placement === 'modal',
            })}
          >
            <PaymentMethodToggleContainer
              method={method}
              isRozetkaDeliveryEnabled={isRozetkaDeliveryEnabled}
            />
          </li>
        ))}
      </ul>
    </>
  );
};
